/* eslint-disable no-unused-vars */
import { cloneDeep } from "lodash";
import axios from "../../axios";
import { PaginationBlank } from "../../utils/types/Pagination";

const state = {
  levels: [],
  pagination: cloneDeep(PaginationBlank()),
};

const actions = {
  /**
   * Fetches all levels from the ERP system.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Function} context.commit - The Vuex commit function.
   * @param {Object} query - The query parameters to be sent with the request.
   * @returns {Promise} - A promise that resolves with the response or rejects with an error.
   */
  async getAllLevels({ commit }, query) {
    return new Promise((resolve, reject) => {
       const searchParams = new URLSearchParams({
        ...query,
        page: query?.page || state.pagination.current_page,
        per_page: query?.per_page || state.pagination.per_page,
      });

      axios
        .get(`/levels-lms?${searchParams}`)
        .then((response) => {
          commit("SET_ALL_LEVELS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  async store({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios
        .post("levels-lms", payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  async update({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`levels-lms/${id}`, payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Delete voucher
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  delete({ commit }, id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`levels-lms/${id}`)
        .then((response) => {
          commit("REMOVE_RECORD", id);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * Sets the current page in the store.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Function} context.commit - The Vuex commit function.
   * @param {number} currentPage - The current page number to set.
   */
  setCurrentPage({ commit }, currentPage) {
    commit("SET_CURRENT_PAGE", currentPage);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_PER_PAGE", data);
  },
};

const mutations = {
  SET_ALL_LEVELS(state, data) {
    state.levels = data.items || [];
    state.pagination = data.pagination || state.pagination;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
  SET_CURRENT_PAGE(state, currentPage) {
    state.pagination.current_page = currentPage;
  },
  REMOVE_RECORD(state, itemId) {
    if (Array.isArray(itemId)) {
      itemId.forEach((item) => {
        const index = state.levels.findIndex((u) => u.id === item);
        state.levels.splice(index, 1);
      });
    } else {
      const index = state.levels.findIndex((u) => u.id === itemId);
      state.levels.splice(index, 1);
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
